import { Navigate, useLocation } from "react-router-dom";
import isEmpty from "lodash/isEmpty";
import TechnicalErrorDuplicateBooking from "app/pages/TechnicalError/duplicateBooking/TechnicalErrorDuplicateBooking";

const TechnicalErrorDuplicateBookingContainer = props => {
	const { state } = useLocation();
	const existingBooking = state?.existingBooking;

	if (!isEmpty(existingBooking)) {
		return (
			<TechnicalErrorDuplicateBooking
				{...props}
				bookingReference={existingBooking.reference}
				email={existingBooking.email}
				endDate={existingBooking.stayTo}
				startDate={existingBooking.stayFrom}
			/>
		);
	}

	return <Navigate to={{ pathname: "/technical-error" }} />;
};

export default TechnicalErrorDuplicateBookingContainer;
